var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('section', {
    staticClass: "w-full h-full flex flex-col items-center"
  }, [_c('SelctUnit', {
    ref: "SelctUnit"
  }), _vm._m(0)], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "flex flex-col items-center justify-center pt-[10%]"
  }, [_c('div', {
    staticClass: "mb-[30px]"
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/home/YC06@2x.png"),
      "alt": $t("c1wsgo5", "未加入企业")
    }
  })]), _c('div', {
    staticClass: "text-[26px] font-bold text-[#000000] mb-[15px]"
  }, [_vm._v(` ${$t("dt4tpwb", "您当前还未加入任何企业")} `)]), _c('div', {
    staticClass: "text-[16px] text-[#858585] mb-[8px] leading-[1.5]"
  }, [_vm._v(` ${$t("k2n2bnt", "请联系您所在企业的管理员获取邀请，或等待管理员发送企业邀请")} `)])]);
}];
export { render, staticRenderFns };